import { useTheme } from '@mui/material';

import { Typography } from '@occc-app/design-system';

import { SankeyNodeProps } from './scan-data-estimated-reimbursements-chart.types';
import {
  LABEL_HEIGHT,
  LABEL_PADDING,
  SANKEY_NODE_WIDTH,
  SANKEY_NODE_RADIUS,
} from './scan-data-estimated-reimbursements-chart.constants';
import {
  getLeftRoundedRectPath,
  getRightRoundedRectPath,
} from './scan-data-estimated-reimbursements-chart.utils';

export const SankeyNode = ({ x, y, width, height, index, payload }: SankeyNodeProps) => {
  const { palette } = useTheme();

  const isSource = index === 0;

  const xPosition = x + SANKEY_NODE_WIDTH + LABEL_PADDING;
  const labelYPosition = Math.max(y, y + (height - LABEL_HEIGHT) / 2);

  const maxLabelWidth = isSource ? '80%' : '50%';

  // Rectangle does not support rounding only specific corners (like left/right only).
  // To match the design, we use a custom SVG path to round just the outer corners of the node.
  const pathData = isSource
    ? getLeftRoundedRectPath(x, y, width, height, SANKEY_NODE_RADIUS)
    : getRightRoundedRectPath(x, y, width, height, SANKEY_NODE_RADIUS);

  return (
    <>
      <path d={pathData} fill={palette.primary.main} />

      <foreignObject
        x={xPosition}
        y={labelYPosition}
        height={LABEL_HEIGHT}
        width='100%'
        style={{ overflow: 'visible' }}
      >
        <Typography
          variant='body2'
          color='text.secondary'
          width={'fit-content'}
          fontSize={{ xs: 10, sm: 12, md: 14 }}
          maxWidth={maxLabelWidth}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {payload.name}
        </Typography>

        <Typography
          variant='body1'
          width={'fit-content'}
          maxWidth={maxLabelWidth}
          fontSize={{ xs: 12, sm: 14, md: 16 }}
          mt={0.5}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {payload.displayValue}
        </Typography>
      </foreignObject>
    </>
  );
};
